<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.33333 0.5H14.6667C14.8877 0.5 15.0996 0.587797 15.2559 0.744078C15.4122 0.900358 15.5 1.11232 15.5 1.33333V14.6667C15.5 14.8877 15.4122 15.0996 15.2559 15.2559C15.0996 15.4122 14.8877 15.5 14.6667 15.5H1.33333C1.11232 15.5 0.900358 15.4122 0.744078 15.2559C0.587797 15.0996 0.5 14.8877 0.5 14.6667V1.33333C0.5 1.11232 0.587797 0.900358 0.744078 0.744078C0.900358 0.587797 1.11232 0.5 1.33333 0.5ZM2.16667 2.16667V13.8333H13.8333V2.16667H2.16667ZM7.16917 11.3333L3.63333 7.7975L4.81167 6.61917L7.16917 8.97667L11.8825 4.2625L13.0617 5.44083L7.16917 11.3333Z" :fill="color"/>
  </svg>
</template>
<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class WcIconSquareTick extends Vue {
  @Prop({ default: '#09121F' }) color!: string
}
</script>
<style scoped>

</style>
